import Modal from 'react-modal';
import './index.css'

type ModalImageProps = {
    isOpen: boolean;
    setIsOpen: (value: boolean) => void;
    urlImage: string;
}



export function ModalImage({ isOpen, setIsOpen, urlImage }: ModalImageProps) {


    return(
        <Modal
            isOpen={isOpen}
            onRequestClose={() => setIsOpen(false)}
            className="modal-image"
            contentLabel="Endereço para entrega"
            overlayClassName="overlay-modal"
            ariaHideApp={false}
        >
            <div className="modal-image-content">
                <div className="title">
                    <svg onClick={() => setIsOpen(false)} width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M0.978551 2.97126L6.957 8.94971L0.978551 14.9282L2.97137 16.921L8.94981 10.9425L14.9283 16.921L16.9211 14.9282L10.9426 8.94971L16.9211 2.97126L14.9283 0.978446L8.94981 6.95689L2.97137 0.978446L0.978551 2.97126Z" fill="#636363"/>
                    </svg>
                </div>
                <img src={urlImage} alt="Image" />
            </div>
        </Modal>
    );
}